export const ixStringToInt = (value: string | number | null): number | null => {
    if (value === null || value === undefined || value === '') {
        return null
    }
    
    if (typeof value === 'number') {
        return value
    }
    
    const parsed = parseInt(value.toString().trim(), 10)
    return isNaN(parsed) ? null : parsed
}